import dayjs from 'dayjs'

const getBuildDate = (epoch) => {
	const buildDate = dayjs(epoch).format('DD-MM-YYYY HH:mm:ss')
	return buildDate
}

export { getBuildDate }
